import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';

import { Observable } from 'rxjs';
import { applicationVersion } from '../../environments/application-version';

export class VersionInterceptor implements HttpInterceptor {
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Clone the request and replace the original headers with cloned headers, updated with the x-syk-client-version.
        const request = req.clone({
            headers: req.headers.set('x-syk-client-version', applicationVersion)
        });

        // send cloned request with header to the next handler.
        return next.handle(request);
    }
}